import { OPEN_MODAL, OPEN_ADD_CONTENT_MODAL, OPEN_DELETE_STIMULUS_MODAL, OPEN_MOVE_IMMUTABLE_MODAL, CLOSE_MODAL } from '@instructure/quiz-common';
export function withConfirm(onContinue) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var defaultConfirmOptions = {
    text: opts.text,
    onContinue: onContinue,
    title: void 0,
    confirmation: true,
    onCancel: void 0,
    continueText: void 0,
    continueVariant: void 0,
    cancelText: void 0,
    size: void 0,
    shouldReturnFocus: true
  };
  var modalOptions = Object.assign({}, defaultConfirmOptions, opts);
  return {
    type: OPEN_MODAL,
    payload: {
      title: modalOptions.title,
      options: modalOptions
    }
  };
}
export function openAddContentModal(data) {
  return {
    type: OPEN_ADD_CONTENT_MODAL,
    payload: {
      allowStimulusCreation: data.allowStimulusCreation,
      parentEntryId: data.parentEntryId,
      position: data.position,
      quizId: data.quizId,
      stimulusId: data.stimulusId
    }
  };
}
export function openDeleteStimulusModal(entry) {
  return {
    type: OPEN_DELETE_STIMULUS_MODAL,
    payload: {
      entry: entry
    }
  };
}
export function openMoveImmutableModal() {
  return {
    type: OPEN_MOVE_IMMUTABLE_MODAL,
    payload: {}
  };
}
export function openModal(title) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: OPEN_MODAL,
    payload: {
      title: title,
      options: opts
    }
  };
}
export function closeModal(title) {
  return {
    type: CLOSE_MODAL,
    payload: {
      title: title
    }
  };
}